import { useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Menu } from 'antd'
import type { MenuProps } from 'antd'
import type { MenuModel } from '@ay-shared-core/types/admin'
import { getUserInfo } from '@/utils/token'
import { getIcon } from '@/config/iconMap'

type MenuItem = Required<MenuProps>['items'][number]

/** 将 MenuModel[] 转换为 antd Menu 的 items */
const buildMenuItems = (menus: MenuModel[]): MenuItem[] => {
  return menus.map((menu): MenuItem => {
    if (menu.children && menu.children.length > 0) {
      return {
        key: menu.path,
        icon: getIcon(menu.icon),
        label: menu.name,
        children: buildMenuItems(menu.children),
      }
    }
    return {
      key: menu.path,
      icon: getIcon(menu.icon),
      label: menu.name,
    }
  })
}

const SideMenu = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const menuItems = useMemo(() => {
    const user = getUserInfo()
    const menus = user?.menus ?? []
    return buildMenuItems(menus)
  }, [])

  const onClick: MenuProps['onClick'] = (e) => {
    navigate(e.key)
  }

  // 获取当前路径对应的菜单 key
  const getSelectedKeys = () => {
    const path = location.pathname
    // 精确匹配
    if (menuItems.some((item) => item?.key === path)) {
      return [path]
    }
    // 查找子菜单
    for (const item of menuItems) {
      if (item && 'children' in item && item.children) {
        const found = item.children.find((child: MenuItem) => child?.key === path)
        if (found) {
          return [path, item.key as string]
        }
      }
    }
    return [path]
  }

  // 获取默认展开的菜单（当前路径的父菜单）
  const getOpenKeys = () => {
    const path = location.pathname
    for (const item of menuItems) {
      if (item && 'children' in item && item.children) {
        const found = item.children.find((child: MenuItem) => child?.key === path)
        if (found) {
          return [item.key as string]
        }
      }
    }
    return []
  }

  return (
    <Menu
      onClick={onClick}
      mode="inline"
      selectedKeys={getSelectedKeys()}
      defaultOpenKeys={getOpenKeys()}
      items={menuItems}
      style={{ fontSize: 14 }}
    />
  )
}

export default SideMenu
